var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "bounce" } }, [
    _vm.show
      ? _c(
          "div",
          { staticClass: "sales-detail-view__container" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.includeHeader,
                    expression: "includeHeader"
                  }
                ],
                staticClass:
                  "css-grid sales-detail-view__row sales-detail-view__row--header"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "css-grid sales-detail-view__category sales-detail-view__category--month"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--month"
                      },
                      [_vm._v("Month")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "css-grid sales-detail-view__category sales-detail-view__category--units"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--current"
                      },
                      [_vm._v("Units")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--prior"
                      },
                      [_vm._v("Prior")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--change"
                      },
                      [_vm._v("Change")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "css-grid sales-detail-view__category sales-detail-view__category--sales"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--current"
                      },
                      [_vm._v("Sales")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--prior"
                      },
                      [_vm._v("Prior")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--change"
                      },
                      [_vm._v("Change")]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "css-grid sales-detail-view__category sales-detail-view__category--asp"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--current"
                      },
                      [_vm._v("ASP")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--prior"
                      },
                      [_vm._v("Prior")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--change"
                      },
                      [_vm._v("Change")]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.months, function(month, index) {
              return _c(
                "div",
                {
                  key: "month.month-" + index,
                  staticClass: "css-grid sales-detail-view__row"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "css-grid sales-detail-view__category sales-detail-view__category--month"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--month"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.displayMonth(month.month, "mmm 'yy", true)
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "css-grid sales-detail-view__category sales-detail-view__category--units"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--current"
                        },
                        [_vm._v(_vm._s(_vm.currency(month.units)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--prior"
                        },
                        [_vm._v(_vm._s(_vm.currency(month.yoy_units)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--change",
                          class: [
                            _vm.getChangePercent(
                              month.units,
                              month.yoy_units
                            ) >= 0
                              ? "sales-detail-view__cell--positive"
                              : "sales-detail-view__cell--negative"
                          ]
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getChangePercent(
                                  month.units,
                                  month.yoy_units
                                )
                              ) +
                              "%\n        "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "css-grid sales-detail-view__category sales-detail-view__category--sales"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--current"
                        },
                        [_vm._v("$" + _vm._s(_vm.currency(month.sales)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--prior"
                        },
                        [_vm._v("$" + _vm._s(_vm.currency(month.yoy_sales)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--change",
                          class: [
                            _vm.getChangePercent(
                              month.sales,
                              month.yoy_sales
                            ) >= 0
                              ? "sales-detail-view__cell--positive"
                              : "sales-detail-view__cell--negative"
                          ]
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getChangePercent(
                                  month.sales,
                                  month.yoy_sales
                                )
                              ) +
                              "%\n        "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "css-grid sales-detail-view__category sales-detail-view__category--asp"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--current"
                        },
                        [
                          _vm._v(
                            "$" +
                              _vm._s(
                                _vm.currency(
                                  _vm.divide(month.sales, month.units)
                                )
                              )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--prior"
                        },
                        [
                          _vm._v(
                            "$" +
                              _vm._s(
                                _vm.currency(
                                  _vm.divide(month.yoy_sales, month.yoy_units)
                                )
                              )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "sales-detail-view__cell sales-detail-view__cell--change",
                          class: [
                            _vm.getChangePercent(
                              _vm.divide(month.sales, month.units),
                              _vm.divide(month.yoy_sales, month.yoy_units)
                            ) >= 0
                              ? "sales-detail-view__cell--positive"
                              : "sales-detail-view__cell--negative"
                          ]
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.getChangePercent(
                                  _vm.divide(month.sales, month.units),
                                  _vm.divide(month.yoy_sales, month.yoy_units)
                                )
                              ) +
                              "%\n        "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }